import { createContractRequest } from './helper';
export const putApplicationSignatureType = createContractRequest({
    route: '/contract/offers/:offerId/application/signatureType',
    method: 'put',
    source: 'data',
});
